<template>
	<div class="showEdit">
		<ShowEditSlideText v-on:hideText="hideText"
						   v-bind:step="step"
						   v-bind:stepIndex="stepIndex"
						   v-bind:textShow="textShow"
						   v-on:reloadText="reloadText($event)"/>

		<ShowEditContent class="showContent"/>

		<ShowEditSlides v-on:showText="showText($event)"
						v-on:reloadShow="reloadShow"
						v-bind:show="show"
						v-bind:test="test"
						v-bind:key="test"/>
	</div>
</template>

<script>
	import isLoggedIn from '@/services/IsLoggedIn.js';
	import ShowEditContent from '../components/show_edit/ShowEditContent';
	import ShowEditSlides from '../components/show_edit/ShowEditSlides';
	import ShowEditSlideText from '../components/show_edit/ShowEditSlideText';
	import Show from '@/services/Show';
	import {EventBus} from '@/services/EventBus.js';

	export default {
		name: "ShowEdit",
		components: {
			ShowEditContent,
			ShowEditSlides,
			ShowEditSlideText
		},
		methods: {
			showText(param) {
				this.textShow = true;
				if (this.step.id !== param.step.id) {
					this.step = param.step;
					this.stepIndex = param.index;
				}
			},
			async hideText() {
				this.textShow = false;
			},
			async setShow() {
				let show = await Show.get(this.$route.params.id);
				let steps = show.steps;
				show.steps = [];

				for (let stepId in show.step_order) {

					let currentStep = steps.find(step => step.id === show.step_order[stepId]);
					if (!currentStep) {
						show.step_order = show.step_order.filter(stepOrder => stepOrder !== show.step_order[stepId]);
						await Show.put(show);
					} else {
						show.steps.push(currentStep);
					}
				}

				this.show = show;
				this.test++;
			},
			async reloadText(step) {
				this.step = step;
				this.textShow = false;
			},
			async reloadShow() {
				await this.setShow();
			}
		},
		data() {
			return {
				show: {},
				step: {},
				stepIndex: 0,
				test: 1,
				textShow: false
			}
		},
		async created() {
			(await isLoggedIn() === false) ? this.$router.push('/login') : '';
			await this.setShow();
			EventBus.$emit('onCurrentShow', this.show.id);
			EventBus.$emit('onSelectedMenuItem', 'Editieren');
		}
	}
</script>

<style scoped>

	.showEdit {
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.showContent {
		height: 0px;
	}
</style>